import net from 'net';
import type { ManagementCommand, ManagementEndpoint, SendCommandOptions } from '../../types/manage.d.ts';

export function sendCommand(
    server: ManagementEndpoint,
    command: ManagementCommand,
    options: SendCommandOptions = {}
): Promise<unknown> {
    const { timeout = 5000 } = options;

    // Determine connection target: named pipe/socket path or port
    const connectOptions: net.NetConnectOpts = server?.path
        ? { path: server.path }
        : { port: server?.port ?? 0 };

    const target = server?.path ?? `port ${server?.port}`;

    return new Promise((resolve, reject) => {
        const client = net.connect(connectOptions, () => {
            client.write(JSON.stringify(command));
        });

        const timeoutId = setTimeout(() => {
            client.destroy();
            reject(new Error(`Connection timed out after ${timeout}`));
        }, timeout);

        client.on('data', (data) => {
            clearTimeout(timeoutId);
            try {
                const response = JSON.parse(data.toString());
                if (response.error) {
                    reject(new Error(response.error));
                }
                else {
                    resolve(response.result);
                }
            }
            catch {
                // Not JSON, return as raw string
                resolve(data.toString());
            }
            client.end();
        });

        client.on('error', (err: NodeJS.ErrnoException) => {
            clearTimeout(timeoutId);
            if (err.code === 'ENOENT' || err.code === 'ECONNREFUSED') {
                reject(new Error(`Cannot connect to gateway at ${target}. Make sure the gateway server is running and the path is correct.`, { cause: err }));
            }
            else {
                reject(err);
            }
        });
    });
}

